// eslint-disable-next-line @typescript-eslint/no-unused-vars
const _solrCors = ['resource_center', 'dev_obj'] as const;
type CoreName = (typeof _solrCors)[number];

export default class SolrCore {
  readonly #coreName: CoreName;

  public static resourceCenter = new SolrCore('resource_center');

  public static devObj = new SolrCore('dev_obj');

  private constructor(coreName: CoreName) {
    this.#coreName = coreName;
  }

  public compareTo(other: SolrCore): boolean {
    return this.#coreName === other.asString();
  }

  /** DO NOT USE FOR COMPARISON, use compareTo */
  public asString(): string {
    return this.#coreName;
  }
}
